import router from '@/router';
import store from '@/store';

export const goDetail = (id, type, linkType, src) => {
  if (linkType === '1') {
    window.open(src);
  } else {
    store.commit('SET_ROUTER_INDEX', type);
    router.push({ path: '/detail', query: { type, id } });
  }
};

export const goList = (type, name) => {
  store.commit('SET_ROUTER_INDEX', type);
  router.push({
    path: '/list',
    query: { type, name },
  });
};

export const goWapDetail = (id, type, linkType, src) => {
  if (linkType === '1') {
    window.open(src);
  } else {
    store.commit('SET_WAP_ROUTER_INDEX', type);
    router.push({ path: '/mobile/wap-detail', query: { type, id } });
  }
};

export const goWapList = (type, name) => {
  store.commit('SET_WAP_ROUTER_INDEX', type);
  router.push({
    path: '/mobile/wap-list',
    query: { type, name },
  });
};

export const openView = (linkUrl) => {
  if (!linkUrl) return;
  window.open(linkUrl);
};
